const SectionHeader = ({icon, title, className}) => {
    return (
        <div className={`section-header icon-header ${className}`}>
            <h1 className="page-title">{title}</h1>
            <span>{icon}</span>
        </div>
    )
}

export default SectionHeader